import { User } from './../../model/user.model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'rules-of-behavior',
    templateUrl: './rules-of-behavior.component.html',
    styleUrls: ['./rules-of-behavior.component.scss']
})
export class RulesOfBehaviorComponent implements OnInit {
    @Input() readOnly: boolean = false;

    user: User = {};

    constructor() {}

    ngOnInit(): void {
        if (!this.readOnly) {
            this.getUser();
            this.getRobDocument();
        }
    }

    getUser() {}

    getRobDocument() {}

    sign() {}
}
